import { FileTypeKey } from "../../../logics/enums/FileTypeKey";

// for fileList only
export const getLightboxModalProps = childProps => {
    const {
        // for image and fileList
        src,
        alt,
        mime_type,
        lightboxFileType,
    } = childProps;

    return {
        ...(lightboxFileType !== FileTypeKey.UNSUPPORTED && {'content-caption': alt}),
        'content-file-name': alt,
        'content-src': src,
        'content-mime-type': mime_type,
        'content-lightbox-file-type': lightboxFileType,
        // 'item-show-download': lightboxFileType === FileTypeKey.IMAGE,
    };
};
